import { PageRef } from '@wix/editor-platform-sdk-types';

import { EditorAppContext } from './types';
import { getComponentRef } from './getComponentRef';

export async function installSearchResultsPage(
  appContext: EditorAppContext,
): Promise<PageRef | undefined> {
  const { editorSDK, appDefinitionId } = appContext;

  const searchResultsWidgetRef = await getComponentRef(editorSDK);
  if (!searchResultsWidgetRef) {
    return undefined;
  }

  return editorSDK.components.getPage(appDefinitionId, {
    componentRef: searchResultsWidgetRef,
  });
}
